import { FC, useState, Fragment } from 'react';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { ImportFCLData } from '@/types/tableImportFCL';

import InvoiceDetail from './InvoiceDetail';

type ModalDetailsProps = {
  rowData: ImportFCLData;
};

const ModalDetailImportFCL: FC<ModalDetailsProps> = ({ rowData }) => {
  const [isDialogShown, setIsDialogShown] = useState(false);
  const { t } = useTranslation('importFCL');

  const toggleDialog = () => {
    setIsDialogShown(!isDialogShown);
  };

  const dialogHeader = (
    <div className="text-blue-800">
      <FontAwesomeIcon icon={faEye} style={{ marginRight: '0.5rem' }} />
      {t('containerDetail')}
    </div>
  );

  return (
    <>
      <FontAwesomeIcon
        icon={faEye}
        onClick={toggleDialog}
        style={{ cursor: 'pointer' }}
      />

      {isDialogShown && (
        <Dialog
          header={dialogHeader}
          visible
          style={{
            maxWidth: window.innerWidth <= 1200 ? '95vw' : '1200px',
            minWidth: window.innerWidth <= 1200 ? '95vw' : '1200px',
          }}
          onHide={toggleDialog}
          modal
          breakpoints={{ '1200px': '95vw' }}
        >
          <div className="p-4 pt-0">
            <InvoiceDetail data={rowData} />
          </div>
        </Dialog>
      )}
    </>
  );
};

export default ModalDetailImportFCL;
